import HandToolsInsiderLogo from './logo'
import {handToolsInsiderStylesUS} from './styles'

const baseConfig = {
  domainName: 'handtoolsinsider' as const,
  domainType: 'insider' as const,
  siteName: 'Hand Tools Insider',
  logo: <HandToolsInsiderLogo className="size-10 shrink-0 tablet:size-8" />,
  favicon: '/favicons/handtoolsinsider.png',
}

const localeConfigs = {
  us: {
    measurementId: 'G-4QTGNS7DHZ',
    camelCaseUrl: 'HandToolsInsider.com',
    title: (category: string, count: string) => `Hand Tools Insider | Top ${count} Insider Choices for ${category}`,
    description: (_category?: string, count?: string) =>
      `Craft with confidence. Top ${count} power tools, chosen by experts. Elevate your skills with insider picks. Precision, durability, and real results.`,
    styles: handToolsInsiderStylesUS,
  },
}

export const createConfig = (locale: string = 'us') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.us
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
